import {request} from '@/network/request'
//动态/工作图片
export function getDynamicHomeImg(query) {
  return request({
    url: '/gaoligong/dynamic/getDynamicHomeImg' ,
    method: 'get',
    params: query
  })
}
//动态资讯查看详情
export function getObjInformation(id) {
  return request({
    url: '/gaoligong/dynamic/' + id,
    method: 'get'
  })
}
//工作进展详情
export function getObjProgressWork(id) {
  return request({
    url: '/gaoligong/progressWork/' + id,
    method: 'get'
  })
}
//常见问题
export function getObjProblem(id) {
  return request({
    url: '/gaoligong/helpproblem/' + id,
    method: 'get'
  })
}
//练习我们
export function getObjRelationWe(id) {
  return request({
    url: '/gaoligong/relationWe/' + id,
    method: 'get'
  })
}
//图片详情
export function getObjPicture(id) {
  return request({
    url: '/gaoligong/picturevideo/' + id,
    method: 'get'
  })
}
export function getObjvideo(id) {
  return request({
    url: '/gaoligong/video/' + id,
    method: 'get'
  })
}
//详情工作指南
export function getObjFieldData(id) {
  return request({
    url: '/gaoligong/fieldData/' + id,
    method: 'get'
  })
}
//工作指南
export function getObjWorkguide(id) {
  return request({
    url: '/gaoligong/workguide/' + id,
    method: 'get'
  })
}
// export function information(query) {
//   return request({
//     url: '/gaoligong/dynamic/page',
//     method: 'get',
//     params: query
//   })
// }
//首页动态资讯列表
export function information(query) {
  return request({
    url: '/gaoligong/dynamic/getNotPermissionsDynamic',
    method: 'get',
    params: query
  })
}
//首页工作进展列表
export function progressWorkInfo(query) {
  return request({
    url: '/gaoligong/progressWork/getNotPermissionsDynamic',
    method: 'get',
    params: query
  })
}
export function pictureVideoInfo(query) {
  return request({
    url: '/gaoligong/picturevideo/getNotPermissionsPictureVideo',
    method: 'get',
    params: query
  })
}

/***
 * 帮助文档
 */
export function getObjHelpDocuments(id) {
  return request({
    url: '/gaoligong/helpDocuments/' + id,
    method: 'get'
  })
}

/**
 * 标准规范
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getObjStandardSpecification(id) {
  return request({
    url: '/gaoligong/standardSpecification/' + id,
    method: 'get'
  })
}